import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';

const InfoTip = ({ text }) => {
  const [coords, setCoords] = useState(null);
  const iconRef = useRef(null);
  if (!text) return null;
  const handleEnter = () => {
    if (!iconRef.current) return;
    const r = iconRef.current.getBoundingClientRect();
    setCoords({ top: r.top + window.scrollY, left: r.left + r.width / 2 + window.scrollX });
  };
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 3 }}>
      <span ref={iconRef} onMouseEnter={handleEnter} onMouseLeave={() => setCoords(null)}
        style={{ cursor: 'help', color: '#c8b89a', fontSize: '0.62rem', lineHeight: 1, userSelect: 'none' }}>ⓘ</span>
      {coords && createPortal(
        <span style={{
          position: 'absolute', top: coords.top - 8, left: coords.left,
          transform: 'translate(-50%, -100%)',
          background: '#1e3a5f', color: '#fff', borderRadius: 7,
          padding: '8px 11px', fontSize: '0.68rem', lineHeight: 1.5,
          width: 240, zIndex: 99999, boxShadow: '0 6px 24px rgba(0,0,0,0.28)',
          pointerEvents: 'none', whiteSpace: 'normal', fontWeight: 400, letterSpacing: 0, textTransform: 'none',
        }}>
          {text}
          <span style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', borderWidth: 5, borderStyle: 'solid', borderColor: '#1e3a5f transparent transparent transparent' }} />
        </span>,
        document.body
      )}
    </span>
  );
};

export default InfoTip;
